export default __webpack_public_path__ + "static/media/chest.cf5f2c07.png";